import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[ecomNgTransclude]',
    standalone: false
})
export class EcomNgTranscludeDirective {
  public viewRef: ViewContainerRef;

  protected _viewRef: ViewContainerRef;
  protected _ngTransclude: TemplateRef<any>;

  @Input()
  public set ecomNgTransclude(templateRef: TemplateRef<any>) {
    this._ngTransclude = templateRef;
    if (templateRef) {
      this.viewRef.createEmbeddedView(templateRef);
    }
  }

  public get ecomNgTransclude(): TemplateRef<any> {
    return this._ngTransclude;
  }

  public constructor(viewRef: ViewContainerRef) {
    this.viewRef = viewRef;
  }
}
